import { format } from "date-fns";

import { ReportFieldDisabledValue } from "@components/ReportField/ReportFieldDisabledValue";
import { ReportFieldDate } from "@components/ReportField/inputs/ReportFieldDate";
import { parseStoredDate } from "@components/ReportField/inputs/dateFieldUtils";
import { ReportFieldInputBaseProps, UpdateReportSectionFieldMutateOptions } from "@components/ReportField/types";

export const TreatmentPlanDate: React.FC<ReportFieldInputBaseProps> = ({
  id,
  value,
  onChange,
  variant,
  disabled,
  onFocus,
  onBlur,
}) => {
  if (disabled) return <ReportFieldDisabledValue value={value} />;

  const handleChange = (next: string, mutateOptions?: UpdateReportSectionFieldMutateOptions) => {
    const parsed = parseStoredDate(next);
    return onChange(parsed ? format(parsed, "yyyy-MM-dd") : next, mutateOptions);
  };

  return (
    <ReportFieldDate
      value={value}
      onChange={handleChange}
      onFocus={onFocus}
      onBlur={onBlur}
      variant={variant}
      id={id}
    />
  );
};
